import brandAPI from '@/app/apis/main/brands/brands-api.js';

export default {
	/**
	 * @return {object} brand list
	 * @params {queryParams} - productType
	 * */
	async getBrands(queryParams) {
		return brandAPI.getBrands(queryParams);
	}
}